const baseurl = () =>
  process.env.NODE_ENV !== 'production' ? 'http://localhost:4000/' : '/';
export const ConfigService = {
  urlBaseServiceItems: `${baseurl()}api/getListItems`,
  urlBaseServiceSections: `${baseurl()}api/getSectionsItems`,
  urlBaseServiceSendEncuesta: `${baseurl()}api/sendEncuesta`,
  urlBaseServicevalidExist: `${baseurl()}api/exists`,
  urlBaseGetEncuesta: `${baseurl()}api/getEncuesta`
};
